import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const constatEndpoint = `${apiUrl}/smq/Constat`;

const responsePayload = (response) => {
  const payload = response?.data;

  if (payload?.status === false) {
    throw new Error(payload.message || "Une erreur est survenue");
  }

  return payload;
};

const serviceError = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Le service des constats est indisponible";

const ConstatService = {
  async getRegistre() {
    try {
      return responsePayload(await axios.get(constatEndpoint));
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async getDashboard(filters = {}) {
    try {
      return responsePayload(
        await axios.get(`${constatEndpoint}/dashboard`, { params: filters })
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async getDashboardOverdue(filters = {}) {
    try {
      return responsePayload(
        await axios.get(`${constatEndpoint}/dashboard_overdue`, {
          params: { ...filters, detail_type: "expired" },
        })
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async getDashboardDetails(detailType, filters = {}) {
    try {
      return responsePayload(
        await axios.get(`${constatEndpoint}/dashboard_overdue`, {
          params: { ...filters, detail_type: detailType },
        })
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async getDashboardRecent(filters = {}) {
    try {
      return responsePayload(
        await axios.get(`${constatEndpoint}/dashboard_recent`, {
          params: filters,
        })
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async getConstat(constatId) {
    try {
      return responsePayload(await axios.get(`${constatEndpoint}/${constatId}`));
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async getNextIndex(triggerId = null) {
    try {
      return responsePayload(await axios.get(`${constatEndpoint}/next_index`, { params: { trigger_id: triggerId } }));
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async createConstat(data) {
    try {
      return responsePayload(await axios.post(constatEndpoint, data));
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async createConstatStep(data) {
    try {
      return responsePayload(
        await axios.post(`${constatEndpoint}/constat`, data)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async getAnalysableConstats() {
    try {
      return responsePayload(await axios.get(`${constatEndpoint}/analyse`));
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async getReopenedConstats() {
    try {
      return responsePayload(await axios.get(`${constatEndpoint}/reouvertes`));
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async createCuratif(data) {
    try {
      return responsePayload(
        await axios.post(`${constatEndpoint}/curatif`, data)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async createAnalyse(data) {
    try {
      return responsePayload(
        await axios.post(`${constatEndpoint}/analyse`, data)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async createAction(data) {
    try {
      return responsePayload(await axios.post(`${constatEndpoint}/action`, data));
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async updateConstat(constatId, data) {
    try {
      return responsePayload(
        await axios.put(`${constatEndpoint}/${constatId}`, data)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async updateConstatStep(constatId, data) {
    try {
      return responsePayload(
        await axios.put(`${constatEndpoint}/constat/${constatId}`, data)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async updateCuratif(constatId, data) {
    try {
      return responsePayload(
        await axios.put(`${constatEndpoint}/curatif/${constatId}`, data)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async updateAnalyse(constatId, data) {
    try {
      return responsePayload(
        await axios.put(`${constatEndpoint}/analyse/${constatId}`, data)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async updateAction(planActionId, data) {
    try {
      return responsePayload(
        await axios.put(`${constatEndpoint}/action/${planActionId}`, data)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async validateAction(planActionId) {
    try {
      return responsePayload(
        await axios.put(`${constatEndpoint}/action_validate/${planActionId}`)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },
  async deleteAction(planActionId) {
    try {
      return responsePayload(
        await axios.delete(`${constatEndpoint}/action/${planActionId}`)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async updateActions(constatId, data) {
    try {
      return responsePayload(
        await axios.put(`${constatEndpoint}/actions/${constatId}`, data)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async createActions(data) {
    try {
      return responsePayload(
        await axios.post(`${constatEndpoint}/actions`, data)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async deleteConstat(constatId) {
    try {
      return responsePayload(await axios.delete(`${constatEndpoint}/${constatId}`));
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async getTrash() {
    try {
      return responsePayload(await axios.get(`${constatEndpoint}/corbeille`));
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async getTrashDetail(constatId) {
    try {
      return responsePayload(
        await axios.get(`${constatEndpoint}/corbeille/${constatId}`)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async restoreConstat(constatId) {
    try {
      return responsePayload(
        await axios.put(`${constatEndpoint}/restaurer/${constatId}`)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },

  async deleteConstatDefinitely(constatId) {
    try {
      return responsePayload(
        await axios.delete(`${constatEndpoint}/corbeille/${constatId}`)
      );
    } catch (error) {
      throw new Error(serviceError(error));
    }
  },
};

export default ConstatService;
